import { Box, Typography, Link as MuiLink, Grid } from "@mui/material";
import PropTypes from "prop-types";
import { colorsFoundation, borderRadius } from "../theme/index.js";
import LocalFireDepartmentOutlinedIcon from "@mui/icons-material/LocalFireDepartmentOutlined";
import WaterDropOutlinedIcon from "@mui/icons-material/WaterDropOutlined";
import ThunderstormOutlinedIcon from "@mui/icons-material/ThunderstormOutlined";
import SecurityOutlinedIcon from "@mui/icons-material/SecurityOutlined";
import HomeOutlinedIcon from "@mui/icons-material/HomeOutlined";
import DirectionsCarOutlinedIcon from "@mui/icons-material/DirectionsCarOutlined";
import FlightOutlinedIcon from "@mui/icons-material/FlightOutlined";
import GavelOutlinedIcon from "@mui/icons-material/GavelOutlined";
import BusinessOutlinedIcon from "@mui/icons-material/BusinessOutlined";
import CategoryOutlinedIcon from "@mui/icons-material/CategoryOutlined";
import typography from "../theme/tokens/typography.js";

BranchSelector.propTypes = {
  data: PropTypes.array,
  selectedSparte: PropTypes.string,
  setSelectedSparte: PropTypes.func,
  setExpanded: PropTypes.func,
};

const sparten = {
  "Auslandsreise-Kranken":
    "In Ländern, mit denen Deutschland kein Sozialversicherungsabkommen hat, braucht man z.B. eine Auslandsreise-KV, da man sonst auf sämtlichen Kosten im Krankheitsfall oder auch Rücktransport nach Hause sitzen bleibt. Aber selbst in Europäischen Ländern empfiehlt sie sich, da die GKV auch dort nur einen kleinen Teil der Kosten übernimmt",
  Bauherrenhaftpflicht:
    "Die Bauherrenhaftpflichtversicherung bietet Ihnen Versicherungsschutz während eines Bauvorhabens. Gegenstand der Bauherrenhaftpflichtversicherung ist es, gegen Sie geltend gemachte Haftpflichtansprüche zu prüfen, berechtigte Ansprüche zu befriedigen und unberechtigte Ansprüche abzuwehren. Bsp.: umstürzendes Baumaterial fällt auf Fußweg und Person wird dabei geschädigt",
  Bauleistung:
    "Schützt Sie vor den finanziellen Folgen der Beschädigung oder der Zerstörung aller Lieferungen und Leistungen für das im Versicherungsschein bezeichnete Bauvorhaben (Neubauleistungen) infolge eines Sachschadens durch z.B. Blitz, Starkregen, Vandalismus",
  BBB: "?",
  Berufshaftpflicht:
    "Die Berufshaftpflichtversicherung deckt den finanziellen Schaden ab, der anderen Personen durch die berufliche Tätigkeit entstehen kann. Für Freiberufler ein Muss, bei Angestellten in der Privathaftpflicht integriert",
  Betreiberhaftpflicht:
    "deckt alle Schäden an Teilen ab, die zur PV-Anlage gehören. Darunter zählen Teile, wie PV-Module, Montagerahmen, Befestigungselemente, Wechselrichter und die Verkabelung. Zusätzlich ist auch die mit der Photovoltaikanlage verbundene und der Versorgung des Gebäudes dienende Speicher abgesichert.",
  Betriebshaftpflicht:
    "Sie leistet Schadensersatz, wenn Sie oder Ihre Mitarbeiter bei der Ausübung von betrieblichen oder beruflichen Tätigkeiten Eigentum Dritter beschädigen, zerstören oder sogar Personen zu Schaden kommen.",
  Betriebsschließung:
    "endgültige Aufgabe des Betriebszwecks bei gleichzeitiger Auflösung der Betriebsorganisation",
  Betriebsunterbrechung:
    "Innerhalb der Gewerbe-Inhaltsversicherung sind bei Betriebsunterbrechung infolge eines Sachschadens die fortlaufende Kosten wie z. B. Lohn und Miete sowie den entgangenen Betriebsgewinn versichert",
  "böswillige Beschädigung":
    "Beschädigung durch Vorsatz (Graffiti am Wohngebäude, Lack am Auto böswillig zerkratzt)",
  Cyber:
    "dient der Absicherung gegen Cyberangriffe und IT-Ausfälle. Sie deckt eigene Schäden und Schäden Dritter",
  "D&O-Exzedent":
    "Anschluss- oder Ergänzungsversicherung zu bestehender D&O-Deckung (D&O-Versicherung schützt vor Ansprüchen des Unternehmens gegen den Geschäftsführer, Manager, CEOs, Vorstände, Aufsichtsräte und Beiräte in Firmen unterschiedlichster Unternehmensformen)",
  Dienstreisekasko:
    "Wenn Arbeitnehmer Dienstreisen mit ihren privaten Fahrzeugen unternehmen, sind Beschädigungen, Zerstörung oder Verlust des FZ durch den Arbeitgeber hierüber versichert.",
  EC: "Extended Coverage-Versicherung (Deckung von Schäden, die einen erweiterten Versicherungs­schutz erfordern und über die konventionelle Deckung von Industrie­versicherungen hinaus­gehen)",
  "EC-Betriebsunterbrechungsversicherung":
    "der Versicherungsschutz der Feuer-BU kann hier um die Gefahren der EC-Versicherung ergänzt werden",
  "EC-Gebäude":
    "Wohngebäudeversicherung inkl. Elementar und z.B. inneren Unruhen oder Streik, keine Überschneidung mit Feuerversicherung",
  "EC-Inhalt":
    "Wohngebäudeversicherung inkl. Elementar und z.B. innere Unruhen oder Streik, keine Überschneidung mit Feuerversicherung",
  Einbruchdiebstahl:
    "unerlaubtes Eindringen in einen abgegrenzten Bereich bei Überwindung eines Hindernisses oder einer besonderen Sicherung gegen Wegnahme",
  Elektronik:
    "Schutz technischer Geräte vor Schäden durch Überspannung, Missgeschicke, Stürze, die techn. Geräte beschädigen, Kurzschluss durch Regenwasser bei geöffneten Fenstern, Diebstahl aus KFZ",
  "Elektronik-BU":
    "deckt den Unterbrechungsschaden, der durch die unterbrochene oder beeinträchtigte technische Nutzbarkeit der im Versicherungsvertrag bezeichneten betriebsfertigen Sachen i.S.d. Elektronikversicherung verursacht wurde",
  Elementar:
    "Schäden aufgrund von Überschwemmung und Rückstau durch Starkregen, Erdrutsch und Ersenkung, Erdbeben, Schneedruck und Lawinen, Vulkanausbruch",
  Fahrerschutz:
    "Der Fahrer ist hier bei einem selbst- oder mitverschuldeten Unfall gegen die finanziellen Folgen von Personenschäden abgesichert. Zu den versicherten Leistungen gehören Verdienstausfall, Kosten für eine Haushaltshilfe, Kosten für behindertengerechte Umbauten, Unterhaltszahlungen für Hinterbliebene sowie Schmerzensgeld",
  Feuer:
    "Schäden aufgrund von z. B. Brand, Blitzschlag, aber auch Sengschäden, Überstrom, Induktion",
  "Feuer-Betriebsunterbrechungsversicherung":
    "Innerhalb der Gewerbe-Inhaltsversicherung sind bei Betriebsunterbrechung infolge eines Blitzeinschlags die fortlaufende Kosten wie z. B. Lohn und Miete sowie den entgangenen Betriebsgewinn versichert",
  "Feuer-Gebäude":
    "Brand, Blitzschlag, aber auch Sengschäden, Überstrom, Induktion",
  "Feuer-Inhalt":
    "Brand, Blitzschlag, aber auch Sengschäden, Überstrom, Induktion",
  "Feuer-Rohbau":
    "Brand, Blitzschlag, aber auch Sengschäden, Überstrom, Induktion",
  Flusskasko:
    "Für Schiffseigner zur Absicherung des finanziellen Risikos bei Schäden am eigenen Schiff, aber auch für Schäden an Dritten, die durch sein Verschulden oder das der Mannschaft entstehen",
  "GAP-Deckung":
    "Teil der KFZ-Vollkasko: übernimmt bei einem geleasten oder kreditfinanzierten Fahrzeug im Falle eines Totalschadens oder eines Diebstahls die Differenz zwischen dem Wiederbeschaffungswert und der sich aus dem Leasing- oder Kreditvertrag ergebenden Restforderung",
  Gebäude:
    "WV leistet bei Schäden, die durch Feuer, Leitungswasser oder Naturgefahren am Wohngebäude entstanden sind",
  "Gebäude (EC)":
    "Wohngebäudeversicherung inkl. Elementar und z.B. inneren Unruhen oder Streik, keine Überschneidung mit Feuerversicherung",
  "Gebäude (Feuer)":
    "Brand, Blitzschlag, aber auch Sengschäden, Überstrom, Induktion",
  "Gebäude/Inhalt":
    "Einbruch, Vandalismus, durch techn. Defekt entstandenes Feuer, Dach einer Lagerhalle abgedeckt (Waren durchnässt)",
  Gewässerschadenhaftpflicht:
    "schützt den Besitzer eines Heizöltanks oder einer anderen Anlage mit wassergefährdenden Stoffen vor den finanziellen Folgen, falls er auf Grund gesetzlicher Haftpflichtbestimmungen als Inhaber eines Heizöltanks oder einer anderen Anlage mit wassergefährdenden Stoffen aus Schäden an Gewässern auf Schadenersatz in Anspruch genommen wird",
  "Gewerbe Gebäude": "zu gewerblichen Zwecken genutztes Gebäude",
  Gewinnbeteiligung:
    "Form des Arbeitsentgelts. An Stelle oder zusätzlich zu einem Festgehalt erhält ein AN einen Anteil am Jahresüberschüss des Unternehmens",
  Glas: "Bruchschäden an Verglasung",
  "Haus- und Grundstückshaftpflicht":
    "Die Haus- und Grundbesitzerhaftpflichtversicherung schützt Sie vor Schadensersatzansprüchen Dritter, die durch Schadensereignisse in Zusammenhang mit Ihrem Eigentum entstehen. Bsp.: Auf dem Weg zum Briefkasten Ihrer Immobilie stolpert der Postbote über einen losen Pflasterstein und verletzt sich. Bürgersteig vor ihrem Haus ist im Winter nicht gestreut --> Passant rutscht aus",
  Hausrat:
    "Zum Hausrat gehören alle Gegenstände und Sachen, die in einem Haushalt privat genutzt werden(Inneneinrichtung, Kleidung und technische Geräte), und die nicht fest mit dem Gebäude verbunden sind. Bietet finanzielle Absicherung bei Feuer, austretendem Leitungswasser, Sturm, Einbruchdiebstahl",
  "Hausrat mit Feuer": "",
  "HV D&O":
    "Directors-and-Officers-Versicherung ist eine Vermögensschadenhaftpflichtversicherung, die ein Unternehmen für seine Organe und leitenden Angestellten abschließt. Bsp.: Ein Geschäftsführer erwirbt eine für das Unternehmen ungeeignete EDV-Anlage. Durch seine unzureichenden Erkundigungen über die Anlage fallen erhebliche Nachbesserungen an. Fehler bei Vertragsabschlüssen. Der Aufsichtsrat einer Firma unterlässt es, das Vorstandsmitglied wegen rechtswidriger Finanztransaktionen persönlich in Regress zu nehmen.",
  "HV Privat":
    "„Wer vorsätzlich oder fahrlässig das Leben, den Körper, die Gesundheit, die Freiheit, das Eigentum oder ein sonstiges Recht eines anderen widerrechtlich verletzt, ist dem anderen zum Ersatz des daraus entstehenden Schadens verpflichtet“ (§ 823 BGB). Bsp.: Während eines Abendessens bei Freunden entglitt dem Gast ein volles Glas Rotwein. Dabei wurde der weiße Teppich in Mitleidenschaft gezogen. Ein Inlineskater fuhr morgens mit hohem Tempo seine täglichen Runden um den See. Beim Zusammenstoß mit Passantin brach diese sich das Handgelenk--> Regressforderung: 15.000 EUR",
  Inhalt:
    "Schützt Firmenbesitzer bei Schäden durch Durch Einbruch, Brand oder Unwetter. Sichert Betriebsausstattung.",
  "Inhalt (EC)":
    "erweiterte Deckung inkl. Elementar, keine Überschneidung mit Feuerversicherung",
  "Inhalt (Feuer)":
    "Absicherung Blitzschlag / Feuer in Bezug auf Betriebsausstattung. Bsp.: die Pommes gehen weg wie nix. Doch dann setzt die Fritteuse die halbe Küche in Brand. Auch der Gastraum ist voller Qualm und Ruß.",
  Kasko:
    "Die Teil- bzw. Vollkaskoversicherung spannt das Sicherheitsnetz auch um Ihr eigenes Kfz. Sie zahlt zum Beispiel, wenn Ihr Auto gestohlen wird, mit Wildtieren kollidiert und bei selbstverschuldeten Schäden am eigenen Wagen.",
  "KFZ - Haftpflicht":
    "Sie leistet, wenn andere Personen oder andere Sachen geschädigt werden",
  "KFZ - Haftpflicht (11 %)": "",
  "KFZ - Haftpflicht (schwer)": "",
  "KFZ - Schutzbrief":
    "Der Kfz-Schutzbrief garantiert im Notfall einen Anspruch auf Pannenhilfe inklusive Abschleppdienst. Ist das Auto nicht mehr fahrtüchtig, werden außerdem auf Reisen die Kosten für einen Mietwagen (Pkw) übernommen. Der Kfz-Schutzbrief umfasst noch viele weitere Leistungen, wie beispielsweise Krankenrücktransport aus dem Urlaub. Eine Notrufzentrale steht dem Autofahrer dabei unterstützend zur Verfügung.",
  "KFZ - Schutzbrief (11 %)": "",
  "KFZ - Teilkasko":
    "Die Teilkasko ersetzt Schäden an Ihrem eigenen Fahrzeug, die z.B. durch Brand, Kurzschluss, Diebstahl, Sturm oder Tiere verursacht werden. ",
  "KFZ - Teilkasko (11 %)": "",
  "KFZ - Teilkasko (schwer)": "",
  "KFZ - Vollkasko / Teilkasko (11 %)": "",
  "KFZ - Vollkasko / Teilkasko (schwer)": "",
  "KFZ - Vollkasko/Teilkasko":
    "Die Vollkasko ergänzt diesen Schutz um Schäden am eigenen Fahrzeug und Vandalismusschäden.",
  "KfZPolice-classic": "",
  "Kidnap & Ransom":
    "Lösegeldversicherung für Unternehmen, die ihre Mitarbeiter absichern möchten, oder NGOs, die Entwicklungshilfe im Ausland leisten, oder Privatkunden",
  Kunst: "",
  Leitungswasser:
    "Schäden durch den bestimmungswidrigen Austritt von Leitungswasser ",
  "Luftfahrt-Haftpflicht":
    "Die Halter-Haftpflichtversicherung kommt für Schäden auf, die durch den Betrieb eines bestimmten Luftfahrzeuges bei unbeteiligten Dritten entstehen. Das sind Schäden an fremden Personen oder Sachen die sich nicht am oder im Flugzeug/Fluggerät befinden.",
  Maschinenbruch:
    "Eine Maschinenversicherung übernimmt im Schadenfall je nach Geräteart und Leistungsumfang der gewählten Versicherung die Kosten für eine Reparatur (Teilschaden) bzw. den Ersatz einer kaputten Maschine oder Anlage (Totalschaden) und den vorübergehenden Einsatz von Leihgeräten. Bsp.: Fehlbedienung, Diebstahl, Überlastung einer Arbeitsmaschine, mutwillige Zerstörung",
  "Maschinenbruch-BU":
    "Betriebsunterbrechung durch Maschinenbruch. Abzusichern mit einer Ertragsausfalldeckung",
  Mietverlust:
    "Die Mietverlustversicherung übernimmt bei Mietausfall oder einem Nutzungsausfall nicht nur die ausgefallenen Einnahmen, sondern auch die Nebenkosten wie beispielsweise die Grundsteuer oder die Müllabfuhrgebühren. Mietverlust z.B. durch Sachschäden am Gebäude (Brand, Leitungswasser, Sturm, Hagel, Blitzschlag, Explosion)",
  "Mietverlust (EC)": "",
  "Mietverlust (Feuer)": "",
  "P&I":
    "Die P&I (Protection and Indemnity)-Versicherung ist eine umfassende Haftpflichtversicherung für Schäden gegenüber Dritten. Sie deckt die Haftungsrisiken des Versicherten ab, die aus dem Betrieb des Schiffes entstehen, hier insbesondere: Beschädigung oder Verlust von Ladung, Kollisionshaftung, Wrackbeseitigung, Umweltverschmutzung",
  "Privat Wohngebäude mit Feuer":
    "WV leistet bei Schäden, die durch Feuer, Leitungswasser oder Naturgefahren am Wohngebäude entstanden sind",
  Privathaftpflicht:
    "Leistet Schadenersatz, wenn Sie andere versehentlich schädigen und schützt sie vor unberechtigten Forderungen. Bsp.: Vase beim Nachbarn umgestoßen, Phishing-Mail legt Netzwerk lahm, Schlüsselverlust erfordert neue Schließanlage",
  "Privathaftpflicht für betreute Personen":
    "Verzicht auf diesen Einwand der Deliktunfähigkeit und Erbringung von Schadenersatz je nach vertraglich vereinbarter Summe.",
  "Produkt-Rückrufkosten":
    "Hersteller, Importeure und Händler sind unter anderem aufgrund des Produktsicherheitsgesetzes verpflichtet, Produkte für Endverbraucher zurück zu rufen und ggf. weitere Schadenverhütungsmaßnahmen zu ergreifen. Ziel ist es Personenschäden zu vermeiden, weil von dem Produkt ein Risiko ausgeht oder ausgehen kann. Aufsichtsbehörden sind außerdem ermächtigt, Maßnahmen anzuordnen, die dem Verbraucherschutz dienen. Die Kosten hierfür trägt im jedem Fall das Unternehmen, also der Hersteller, Importeur oder Händler.",
  Rechtsschutz:
    "Eine Rechtsschutzversicherung übernimmt Anwalts- und Gerichtskosten und hilft Ihnen, Ihre Ansprüche unabhängig von den eigenen finanziellen Möglichkeiten durchzusetzen. Bsp.: Arbeitgeber kündigt Ihnen völlig unerwartet fristlos; Nachbarschaftsstreitigkeiten; zu hohe Miet-Nebenkosten",
  "Reise-Insolvenzversicherung":
    "Sinn der Insolvenzversicherung ist es, vor allem Regressforderungen nach eingetretener und angemeldeter Insolvenz zu schützen und andererseits den Kunden einen zusätzlichen Schutz für den Fall einer eintretenden Zahlungsunfähigkeit anzubieten.",
  Reiserücktritt:
    "Können Sie die Reise nicht antreten, werden die Stornokosten übernommen oder die Mehrkosten der verspäteten Anreise",
  Sach: "",
  Schlüsselverlust:
    "Als Teil der Privathaftpflicht: Abhandenkommen privat oder beruflich überlassener Schlüssel und Schlüsselcodekarten",
  Seekasko:
    "versichert ein Schiff gegen Verlust oder Beschädigung durch fast alle Gefahren",
  "Spezial-Strafrechtsschutz":
    "Versicherungsschutz, wenn Ihnen ein vorsätzliches Vergehen vorgeworfen wird (Vergehen sind Straftaten, die im Mindestmaß mit einer Freiheitsstrafe von unter einem Jahr oder Geldstrafe bedroht sind).",
  "Sturm/Hagel":
    "Schäden durch Sturm/Hagel an versicherten Gebäuden oder Gebäudebestandteilen (als Sturm gilt eine wetterbedingte Luftbewegung ab Windstärke 8). ",
  Tierhalterhaftpflicht:
    "Kommt für Personen-, Sach- und Vermögensschäden auf, die Ihr Tier anderen zufügt",
  Transport:
    "Diebstahl von transportierten Waren, Falschauslieferungen, Beschädigungen beim Transport von Waren",
  Umwelthaftpflicht:
    "Die Umwelthaftpflichtversicherung springt ein, wenn Privatpersonen oder Betriebe durch umweltgefährdende Stoffe einen Schaden bei Dritten verursachen. Im privaten Bereich ist die Versicherung des Heizöltanks ratsam. ",
  Umweltschaden:
    "Die Umweltschadenversicherung schützt vor öffentlich-rechtlichen Ansprüchen nach dem Umwelt­schaden­gesetz (USchadG), zum Beispiel durch die gesetzliche Pflicht zur Sanierung von Umweltschäden.",
  Unfall:
    "Ein Unfall liegt vor, wenn die versicherte Person durch ein plötzlich von außen auf ihren Körper wirkendes Ereignis unfreiwillig eine Gesundheitsschädigung erleidet. Bsp.: auf Glatteis ausgerutscht --> Knochenbruch und Hirntrauma; in der Küche in ein Messer gegriffen --> Sehne durchtrennt, Hand dauerhaft in Funktion eingeschränkt",
  Vermögensschaden:
    'Echte Vermögensschäden sind solche Schäden, die nicht auf Personen-oder Sachschäden zurückzuführen sind. Vereinfacht gesagt sind dies Schäden, die sich "nur" auf einem Bankkonto zeigen (Finanzbeamter setzt Körperschaftssteuer zu niedrig an). Unechte VMS: wenn Personen- oder Sachschäden negative Auswirkungen auf ein Vermögen haben (Verdienstausfall nach einem Personenschaden).',
  "Vers. gegen Internet/Wirtschaftsk.":
    "Internetkriminalität sind betrügerische Angriffe über das Internet, um z.B. Betriebsgeheimnisse auszusphäen; Wirtschaftskriminalität, wenn z.B. falsche eine Identität vorgetäucht wird, wenn Zahlungsströme unzulässig umgeleitet werden, oder bei Spionage",
  Vertrauensschaden:
    "Eine Vertrauensschadenversicherung schützt Unternehmen vor Vermögensschäden, die durch vorsätzliche unerlaubte Handlungen von Vertrauenspersonen verursacht werden (Hausmeister bis Vorstand)",
  Warenkredit:
    "Eine Warenkreditversicherung (auch: Kreditversicherung, Kreditausfallversicherung oder Forderungsausfallversicherung) schützt Unternehmen vor unbezahlten Rechnungen bzw. offenen Forderungen. ",
  Zelt: "?",
  "Kfz-Schaden": "??",
  "Sonstige Gefahren (Gebäude/Inhalt)": "??",
  "allgemeine Haftpflicht": "??",
  "Sonstige Schäden": "Schäden, die nicht in die anderen Kategorien passen",
};

// Map sparte names to icons
const getSparteIcon = (sparte) => {
  const iconProps = {
    sx: { fontSize: 32, color: colorsFoundation.neutral[700] },
  };

  // Fire-related
  if (
    sparte.toLowerCase().includes("feuer") ||
    sparte.toLowerCase().includes("brand")
  ) {
    return <LocalFireDepartmentOutlinedIcon {...iconProps} />;
  }

  // Water-related
  if (
    sparte.toLowerCase().includes("leitungswasser") ||
    sparte.toLowerCase().includes("wasser")
  ) {
    return <WaterDropOutlinedIcon {...iconProps} />;
  }

  // Storm/Weather-related
  if (
    sparte.toLowerCase().includes("sturm") ||
    sparte.toLowerCase().includes("hagel") ||
    sparte.toLowerCase().includes("elementar")
  ) {
    return <ThunderstormOutlinedIcon {...iconProps} />;
  }

  // Security/Theft-related
  if (
    sparte.toLowerCase().includes("einbruch") ||
    sparte.toLowerCase().includes("diebstahl")
  ) {
    return <SecurityOutlinedIcon {...iconProps} />;
  }

  // Building-related
  if (
    sparte.toLowerCase().includes("gebäude") ||
    sparte.toLowerCase().includes("haus")
  ) {
    return <HomeOutlinedIcon {...iconProps} />;
  }

  // Vehicle-related
  if (
    sparte.toLowerCase().includes("kfz") ||
    sparte.toLowerCase().includes("kasko") ||
    sparte.toLowerCase().includes("fahrzeug")
  ) {
    return <DirectionsCarOutlinedIcon {...iconProps} />;
  }

  // Travel-related
  if (
    sparte.toLowerCase().includes("reise") ||
    sparte.toLowerCase().includes("ausland")
  ) {
    return <FlightOutlinedIcon {...iconProps} />;
  }

  // Legal/Liability-related
  if (
    sparte.toLowerCase().includes("haftpflicht") ||
    sparte.toLowerCase().includes("recht")
  ) {
    return <GavelOutlinedIcon {...iconProps} />;
  }

  // Business-related
  if (
    sparte.toLowerCase().includes("betrieb") ||
    sparte.toLowerCase().includes("gewerbe") ||
    sparte.toLowerCase().includes("inhalt")
  ) {
    return <BusinessOutlinedIcon {...iconProps} />;
  }

  // Default icon
  return <CategoryOutlinedIcon {...iconProps} />;
};

export default function BranchSelector(props) {
  const { data, selectedSparte, setSelectedSparte, setExpanded } = props;

  const getSpartenBeschreibung = (sparte) => {
    return sparten[sparte];
  };

  const handleSelect = (sparte) => {
    setSelectedSparte(sparte);
    if (setExpanded) {
      setExpanded(1);
    }
  };

  const BranchCard = ({ item }) => {
    const isSelected = item.sparte === selectedSparte;

    return (
      <Box
        onClick={() => handleSelect(item.sparte)}
        sx={{
          width: "100%", // Anpassung an die Grid-Spalte
          backgroundColor: colorsFoundation.neutral[50],
          borderRadius: borderRadius.xs,
          px: 3,
          py: 2,
          height: "100%",
          display: "flex",
          flexDirection: "column",
          alignItems: "center",
          gap: 1,
          cursor: "pointer",
          border: isSelected
            ? `2px solid ${colorsFoundation.key.gold[600]}`
            : "2px solid transparent",
          transition: "all 0.2s ease-in-out",
          "&:hover": {
            border: `2px solid ${colorsFoundation.key.gold[600]}`,
            backgroundColor: `${colorsFoundation.key.gold[50]}`,
          },
        }}
      >
        {/* Icon */}
        <Box
          sx={{
            display: "flex",
            alignItems: "center",
            justifyContent: "center",
          }}
        >
          {getSparteIcon(item.sparte)}
        </Box>

        {/* Title */}
        <Typography
          sx={{
            fontWeight: typography.weight.semibold,
            fontSize: typography.size.lg,
            lineHeight: 1.5,
            color: colorsFoundation.neutral.softblack,
            textAlign: "center",
          }}
        >
          {item.sparte}
        </Typography>

        {/* Description */}
        <Typography
          sx={{
            fontSize: "0.875rem",
            lineHeight: 1.5,
            color: colorsFoundation.neutral.softblack,
            textAlign: "center",
          }}
        >
          {getSpartenBeschreibung(item.sparte)}
        </Typography>

        {/* Melden Link */}
        <MuiLink
          component="button"
          onClick={(e) => {
            e.stopPropagation();
            handleSelect(item.sparte);
          }}
          sx={{
            fontWeight: 600,
            fontSize: "1rem",
            lineHeight: 1.5,
            color: colorsFoundation.neutral.softblack,
            textDecoration: "none",
            cursor: "pointer",
            px: 1.5,
            py: 1,
            "&:hover": {
              textDecoration: "underline",
            },
          }}
        >
          Melden
        </MuiLink>
      </Box>
    );
  };

  return (
    <Box>
      <Typography
        sx={{
          mb: 2,
          fontSize: "1rem",
          color: colorsFoundation.neutral.softblack,
        }}
      >
        Um welche Art Schaden handelt es sich? Wählen Sie die Versicherungsart
        aus.
      </Typography>

      <Grid container spacing={2} sx={{ alignItems: "stretch" }}>
        {data.map((item, index) => (
          <Grid
            key={item.sparte + "-" + index}
            sx={{ display: "flex" }}
            size={{
              xs: 12,
              sm: 6,
              md: 4,
            }}
          >
            <BranchCard item={item} />
          </Grid>
        ))}
      </Grid>
    </Box>
  );
}
